import { SignedIn, SignedOut, SignInButton, UserButton } from "@clerk/clerk-react";

export function HomeRoute() {
  return (
    <main className="shell">
      <section className="card">
        <p className="eyebrow">CCLP Brain</p>
        <h1>Authorize MCP connectors and manage your sessions.</h1>
        <p>
          This site is the OAuth consent + session management surface for the CCLP Brain
          MCP system. You'll usually arrive here from your AI client (Claude Desktop /
          Code / Cowork) when authorizing an MCP connector.
        </p>
        <div style={{ marginTop: 24 }}>
          <SignedOut>
            <SignInButton mode="modal">
              <button className="primary">Sign in</button>
            </SignInButton>
          </SignedOut>
          <SignedIn>
            <p className="hint">Signed in.</p>
            <UserButton />
            <p className="hint" style={{ marginTop: 16 }}>
              <a href="/connections">Manage active connections →</a>
            </p>
          </SignedIn>
        </div>
      </section>
    </main>
  );
}
